// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_V__","cls2":"TranslationModal-cls2_uv8 TranslationModal-cls1_V__"};